import React, { Component } from "react";
import moment from "moment";
import pinyin from "js-pinyin";
import { Form, Input, Modal, Select, InputNumber, DatePicker, message, Button, TimePicker, Spin } from "antd";
import "./styles/patientModal.scss";
import StartCheck from "./startCheck";
// import { throttle } from 'lodash'
import {
  SubmitInspect,
  getTypicalCasesBaseInfo,
  initHospitalDepts,
  initExamRoomList,
  initDeptDoctor,
  getExamItem,
  getPatientSourceList,
  getOtherSettingListNo,
  getPatientInfo,
  getCheckId,
  cancelCollect,
} from "@/request/api";
import { handleEnglishName, handleChangeAgeUnit, changeAge, onChangeBirthday, requestErrorLog } from "@/common/util";
import { receiveMessage, sendMessage } from "../../../request/websocket";

const { Option } = Select;
class patientModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inspectionItem: [], // 检查项目
      doctorList: [], // 申请医生
      departmentList: [], // 申请科室
      hospitalRoomList: [], // 检查科室
      inspectSubclassType: [], //检查子类
      patientsourse: "",
      holterData: "",
      checkVisible: false,
      NAME: "",
      SEX_NAME: "",
      EXAM_UID: "",
      editDisabled: true,
      pressureObj: {
        DayStart: "07:30", //白天开始时间
        DayFinish: "21:00", //白天结束时间
        DayInterval: "5分钟", //白天间隔分钟数
        WhetherFiveMin: "否", //5分钟内开始研究
        NightStart: "21:00", //夜间开始时间
        NightFinish: "07:30", //夜间结束时间
        NightInterval: "5分钟", //夜间间隔分钟数
        WhetherUseKeyboard: "启用", //键盘
        WhetherUseDisplay: "启用", //屏幕是否显示
        Special_1_Start: 0, //特殊1开始时间
        Special_1_Finish: 0, //特殊1结束时间
        Special_1_Interval: 0, //特殊1间隔分钟数
        Special_2_Start: 0, //特殊2开始时间
        Special_2_Finish: 0, //特殊2结束时间
        Special_2_Interval: 0, //特殊2间隔分钟数
        Special_3_Start: 0, //特殊3开始时间
        Special_3_Finish: 0, //特殊3结束时间
        Special_3_Interval: 0, //特殊3间隔分钟数
        WhetherNightTip: "停用", //夜间报警
        WhetherDayTip: "停用", //白天报警
      },
      dateInterval: ["5分钟", "10分钟", "15分钟", "20分钟", "30分钟", "45分钟", "60分钟", "90分钟", "120分钟"],
      loading: false,
      is_NAME_PHONETIC: false, //英文姓名
      is_HEIGHT: false, //身高
      is_EXAM_AGE: false, //年龄
      is_WEIGHT: false, //体重
      is_CROWD_TYPE: false, //人群分类
      is_CHARGE_TYPE: false, //费别
      is_NATIVE_PLACE: false, //籍贯
      is_ZIP_CODE: false, //邮编
      is_INSURANCE_TYPE: false, //医保性质
      is_INSURANCE_CARD_NO: false, //医保卡号
      is_CONTACT_TEL: false, //手机号
      is_ID_NUMBER: false, //身份证号
      is_HOME_ADDRESS: false, //家庭住址
      is_MAILING_ADDRESS: false, //通讯地址
      is_OUTP_NO: false, //门诊号
      is_REQ_DOCTOR_NAME: false, //申请医生
      is_INP_NO: false, //住院号
      is_BED_NO: false, //床号
      is_ROOM_NO: false, //病区
      is_BILLING_DOCTOR: false, //开单医生是否必填
      is_EXAM_ROOM: false, //检查房间
      is_CHARGES: false, //费用
      is_REQ_DATETIME: false, //申请日期
      is_CLIN_DIAG: false, //临床诊断
      is_PHYS_SIGN: false, //体征
      is_CASE_HISTORY: false, //病史
      hisValue: "",
      equipmentType: localStorage.getItem("equipmentType"), //获取心电图机配置信息
      // isSaveDisabled: false, //保存按钮是否禁用
      timestamp: null,
    };
    // 创建节流处理函数，设置节流时间为3000毫秒
    // this.handleSubmitInspect = throttle(this.handleSubmitInspect.bind(this), 3000);
  }

  //检查类型级联菜单
  getExamItemFn = () => {
    const { clickStatus, rowData } = this.props;
    if (parseInt(this.props.showKey) === 4) {
      //待完善列表进来直接默认静息心电类型
      rowData.EXAM_CLASS = "ECG";
    }
    //编辑时给检查子类复制
    this.setState({
      EXAM_SUB_CLASS: rowData.EXAM_SUB_CLASS,
    });
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    if (!userInfo) return;
    let id = userInfo.HOSPITAL_UID;
    getExamItem(id).then((res) => {
      if (res && res.Status === 1) {
        if (!res.Result) return message.error("请先设置检查项目");
        this.setState(
          {
            dataLinkage: res.Result, //所有三级联动数据
            inspectType: res.Result.map((item) => {
              //所有检查类型数据
              return {
                id: item.id,
                name: item.name,
              };
            }),
          },
          () => {
            //不管是新增还是编辑，如果检查类型有数据，检查子类下拉列表数据需要全部带出，如果检查子类有数据，检查项目的下拉列表数据需要全部带出
            if (clickStatus === "EDIT") {
              //编辑
              if (rowData.EXAM_CLASS !== undefined && rowData.EXAM_CLASS !== null) {
                let erji = this.state.dataLinkage.find((item) => item.id === rowData.EXAM_CLASS); //一级数据下的所有二级数据
                if (erji !== undefined) {
                  this.setState(
                    {
                      inspectSubclassType: erji.child.map((item) => {
                        //二级：检查子类的数据
                        return {
                          id: item.id,
                          name: item.name,
                          child: item.child,
                        };
                      }),
                    },
                    () => {
                      if (rowData.EXAM_SUB_CLASS !== undefined && rowData.EXAM_SUB_CLASS !== null) {
                        let sanji = this.state.inspectSubclassType.find((item) => item.id === rowData.EXAM_SUB_CLASS); //二级数据下的所有三级数据
                        if (sanji !== undefined) {
                          this.setState({
                            inspectionItem: sanji.child,
                          });
                        }
                      }
                    }
                  );
                }
              }
            } else if (clickStatus === "ADD") {
              //新增
              if (localStorage.getItem("EXAM_CLASS")) {
                let erji = this.state.dataLinkage.find((item) => item.id === localStorage.getItem("EXAM_CLASS")); //一级数据下的所有二级数据
                console.log(erji, ";二级");
                if (erji !== undefined) {
                  this.setState(
                    {
                      inspectSubclassType: erji.child.map((item) => {
                        //二级：检查子类的数据
                        return {
                          id: item.id,
                          name: item.name,
                          child: item.child,
                        };
                      }),
                    },
                    () => {
                      if (localStorage.getItem("EXAM_SUB_CLASS")) {
                        let sanji = this.state.inspectSubclassType.find(
                          (item) => item.id === localStorage.getItem("EXAM_SUB_CLASS")
                        ); //二级数据下的所有三级数据
                        if (sanji !== undefined) {
                          this.setState({
                            inspectionItem: sanji.child,
                          });
                        }
                      }
                    }
                  );
                } else {
                  this.setState({
                    checkTypeCode: undefined,
                  });
                }
              }
            } else {
              const { dataLinkage } = this.state;
              const checkType = dataLinkage.find((item) => item.id === "ECG");
              let inspectSubclassType = [];
              let checkItem;
              let inspectionItem = [];
              if (checkType) {
                inspectSubclassType = checkType.child.map((item) => ({
                  id: item.id,
                  name: item.name,
                  child: item.child,
                }));
                checkItem = inspectSubclassType[0];
              }
              if (checkItem) {
                inspectionItem = checkItem.child;
              }
              this.setState({
                inspectSubclassType,
                inspectionItem,
              });
            }
          }
        );
      } else {
        requestErrorLog("", "新建/编辑检查类型级联接口报错", 0, true);
      }
    });
  };

  //根据检查类型获取所有检查子类
  getCheckSubClasses = (id) => { };

  componentDidMount() {
    this.allBasicData(); // 初始化基础数据
    this.initHospitalDept();
    this.getExamItemFn();
    this.getMustInputList();
    this.setState({
      timestamp: new Date().getTime(),
    });
    if (parseInt(this.props.showKey) === 4) {
      this.patientInfoData();
    }
    const { clickStatus, rowData } = this.props;
    const rolePrivilege = JSON.parse(localStorage.getItem("roleList"));
    if (rolePrivilege.indexOf("采集") > -1) {
      this.setState({
        editDisabled: false,
      });
    }
    if (clickStatus === "EDIT") {
      this.setState({
        checkTypeCode: rowData.EXAM_CLASS,
        doctorCode: rowData.REQ_DOCTOR_CODE,
        doctorName: rowData.REQ_DOCTOR_NAME
      });
      if (rowData.EXAM_STATUS_NAME !== "未检查") {
        this.setState({
          editDisabled: true,
        });
      }
      this.initDoctor(rowData.REQ_DEPT_CODE);
    }
    if (clickStatus === "ADD" || parseInt(this.props.showKey) === 4 || clickStatus === "EASY") {
      let pressureObj = JSON.parse(localStorage.getItem("pressureObj")) || {};
      if (Object.keys(pressureObj).length > 0) {
        this.setState({ pressureObj });
      }
      this.setState({
        //EXAM_SUB_CLASS检查子类
        itemName: localStorage.getItem("ITEM_NAME") || undefined,
        itemCode: localStorage.getItem("ITEM_CODE") || undefined,
        // checkTypeCode: !localStorage.getItem("EXAM_CLASS") ? "" : localStorage.getItem("EXAM_CLASS"),
        checkTypeCode:
          parseInt(this.props.showKey) === 4
            ? "ECG"
            : localStorage.getItem("EXAM_CLASS")
              ? localStorage.getItem("EXAM_CLASS")
              : "",
        checkTypeName: localStorage.getItem("EXAM_CLASSName") || undefined,
        EXAM_SUB_CLASS: localStorage.getItem("EXAM_SUB_CLASS") || undefined,
        doctorCode: clickStatus === "EASY" ? localStorage.getItem("REQ_DOCTOR_CODE") : undefined,
      });
    }
  }

  patientInfoData = () => {
    //通过examuid获取患者基本信息并回填编辑框
    let params = {
      Type: "GetPatientList",
      EXAM_UID: this.props.rowData.EXAM_UID,
    };
    cancelCollect(params).then((res) => {
      if (res && res.Status === 1) {
        this.props.onClickRow(res.Result[0]);
      } else {
        requestErrorLog(this.props.rowData.EXAM_UID, "新建/编辑获取患者基本信息接口报错", 0, true);
      }
    });
  };

  allBasicData = () => {
    //患者来源
    let params = { pageNo: 1, pageSize: 10, NAME: "" };
    getPatientSourceList(params).then((res) => {
      if (res && res.Status === 1) {
        this.setState(
          {
            sourceType: res.Result.dataList,
          },
          () => {
            this.setState({
              patientsourse:
                this.props.clickStatus === "EASY"
                  ? this.state.sourceType[0]?.PATIENT_SOURCE_CODE
                  : localStorage.getItem("PATIENT_SOURCE") || undefined,
            });
          }
        );
      } else {
        requestErrorLog("", "新建/编辑患者来源列表接口报错", 0, true);
      }
    });
    getTypicalCasesBaseInfo().then((res) => {
      if (res && res.Status === 1) {
        const basicsdata = res.Result.basicsdata;
        Object.values(basicsdata).forEach((item) => {
          switch (item.name) {
            case "费别":
              this.setState({
                costType: item,
              });
              break;

            case "性别":
              this.setState({
                sexType: item,
              });
              break;

            case "人群分类":
              this.setState({
                crowdType: item,
              });
              break;

            case "医保性质":
              this.setState({
                medInsType: item,
              });
              break;
            default:
              break;
          }
        });
      } else {
        requestErrorLog("", "新建/编辑获取基础信息接口报错", 0, true);
      }
    });
  };

  getCheckIdWeb = async () => {
    let param = {
      Type: "CheckId",
      FILE_UID: this.state.hisValue,
    };
    let resdata = await getCheckId(param).then((res) => {
      if (res && res.Status === 1) {
        console.log(res.Result);
        if (res.Result === null) {
          return "";
        }
      } else {
        requestErrorLog("", "息心电图机选择光电12导接口报错", 0, true);
      }
    });
    return resdata;
  };
  handleSubmitInspect = (value) => {
    const {
      itemName,
      fromType,
      itemCode,
      deptName,
      deptCode,
      doctorName,
      doctorCode,
      examDeptName,
      examDeptCode,
      checkTypeCode,
      checkTypeName,
      equipmentType,
    } = this.state;
    const { rowData, clickStatus } = this.props;
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    // this.setState({ isSaveDisabled: true });
    this.props.form.validateFields(async (err, values) => {
      //点击接收心电图机数据按钮需要判断唯一号是否必填。心电图机为光电12导(服务器)-xml
      if (value === "getEcgData" && parseInt(equipmentType) > 100) {
        if (this.state.hisValue.trim() !== "") {
          let resvalue = await this.getCheckIdWeb();
          if (resvalue === "") {
            message.error("唯一号不存在");
            return;
          }
        } else {
          message.warn("请输入唯一号");
          return;
        }
      }
      let creatuser = "";

      if (!err) {
        var ITEM_NAME = this.state.inspectionItem.find((item) => item.id === values.ITEM_NAME);
        if (clickStatus === "ADD" || clickStatus === "EASY") {
          localStorage.setItem("PATIENT_SOURCE", values.PATIENT_SOURCE); //患者来源patientsourse
          localStorage.setItem("EXAM_CLASS", checkTypeCode || values.EXAM_CLASS); //检查类型checkTypeCode
          localStorage.setItem("EXAM_CLASSName", checkTypeName); //检查类型checkTypeCName
          // 2025年3月7日注释
          // var ITEM_NAME = this.state.inspectionItem.find((item) => item.id === values.ITEM_NAME);
          localStorage.setItem("ITEM_NAME", itemName || ITEM_NAME?.name); //检查项目
          localStorage.setItem("ITEM_CODE", itemCode || values.ITEM_NAME); //检查项目
          localStorage.setItem("REQ_DEPT_NAME", deptName); //申请科室
          localStorage.setItem("REQ_DEPT_CODE", deptCode || values.REQ_DEPT_NAME); //申请科室
          localStorage.setItem("EXAM_SUB_CLASS", values.EXAM_SUB_CLASS); //检查子类

          creatuser = userInfo.USER_UID;
        }
        if (clickStatus === "EDIT") {
          creatuser = rowData.CREATE_USER_UID;
        }
        let Params = {
          Type: clickStatus === "EDIT" ? "EDIT" : "ADD",
          hospital_Name: userInfo.HOSPITAL_NAME,
        };
        //取检查类型和检查子类的名字

        let EXAM_SUB_CLASS_NAME = "";
        let EXAM_CLASS_NAME = "";
        console.log(this.state);
        for (let i = 0; i < this.state.inspectType.length; i++) {
          if (this.state.inspectType[i].id === values.EXAM_CLASS) {
            EXAM_CLASS_NAME = this.state.inspectType[i].name;
            break;
          }
        }
        for (let i = 0; i < this.state.inspectSubclassType.length; i++) {
          if (
            this.state.inspectSubclassType[i].id === values.EXAM_SUB_CLASS ||
            this.state.inspectSubclassType[i].id === this.state.EXAM_SUB_CLASS
          ) {
            EXAM_SUB_CLASS_NAME = this.state.inspectSubclassType[i].name;
            break;
          }
        }
        let RequestModel = {
          ...rowData,
          VERIFICATION_CODE: this.state.timestamp, //增加时间戳
          HOSPITAL_CODE: clickStatus === "EDIT" ? rowData.HOSPITAL_CODE : userInfo.HOSPITAL_CODE,
          NAME: values.NAME,
          NAME_PHONETIC: values.NAME_PHONETIC,
          SEX: values.SEX,
          HEIGHT: values.HEIGHT || 0,
          PATIENT_ID: values.PATIENT_ID,
          EXAM_AGE: values.EXAM_AGE || 0,
          AGE_UNIT: values.AGE_UNIT,
          BIRTHDAY: moment(values.BIRTHDAY).format("YYYY-MM-DD"),
          WEIGHT: values.WEIGHT || 0,
          CROWD_TYPE: values.CROWD_TYPE,
          CHARGE_TYPE: values.CHARGE_TYPE,
          NATIVE_PLACE: values.NATIVE_PLACE,
          ZIP_CODE: values.ZIP_CODE,
          INSURANCE_TYPE: values.INSURANCE_TYPE,
          INSURANCE_CARD_NO: values.INSURANCE_CARD_NO,
          CONTACT_TEL: values.CONTACT_TEL,
          ID_NUMBER: values.ID_NUMBER,
          HOME_ADDRESS: values.HOME_ADDRESS,
          MAILING_ADDRESS: values.MAILING_ADDRESS,
          EXAM_NO: values.EXAM_NO,
          ACCESSIONNUMBER: values.ACCESSIONNUMBER,
          PATIENT_SOURCE: values.PATIENT_SOURCE,
          EXAM_CLASS: values.EXAM_CLASS, //检查类型
          OUTP_NO: values.OUTP_NO,
          EXAM_SUB_CLASS: values.EXAM_SUB_CLASS, //检查子类
          INP_NO: values.INP_NO,
          BED_NO: values.BED_NO,
          ROOM_NO: values.ROOM_NO,
          EXAM_ROOM: values.EXAM_ROOM, //检查房间
          CHARGES: values.CHARGES,
          REQ_DATETIME: values.REQ_DATETIME.format("YYYY-MM-DD HH:mm:ss"),
          CLIN_DIAG: values.CLIN_DIAG,
          PHYS_SIGN: values.PHYS_SIGN,
          CASE_HISTORY: values.CASE_HISTORY,
          //CREATE_USER_UID: userInfo.USER_UID,   // 创建人只保存新建时的医生
          // 2025年3月7日注释
          // ITEM_NAME: itemName || ITEM_NAME?.name || rowData.ITEM_NAME, // 检查项目NAME
          // ITEM_CODE: itemCode || values.ITEM_NAME || rowData.ITEM_CODE, // 检查项目CODE
          ITEM_NAME: ITEM_NAME?.name,
          ITEM_CODE: values.ITEM_NAME,
          // 20250314修改
          // REQ_DEPT_NAME: deptName || rowData.REQ_DEPT_NAME, // 申请科室NAME
          // REQ_DEPT_CODE: deptCode || rowData.REQ_DEPT_CODE, // 申请科室CODE
          // REQ_DOCTOR_NAME: doctorName || rowData.REQ_DOCTOR_NAME, // 申请医生NAME
          // REQ_DOCTOR_CODE: doctorCode || rowData.REQ_DOCTOR_CODE, // 申请医生CDOE
          REQ_DEPT_NAME: deptName,
          REQ_DEPT_CODE: deptCode,
          REQ_DOCTOR_NAME: doctorName,
          REQ_DOCTOR_CODE: doctorCode,
          EXAM_DEPT_NAME: examDeptName || rowData.EXAM_DEPT_NAME, // 检查科室NAME
          EXAM_DEPT_CODE: examDeptCode || rowData.EXAM_DEPT_CODE, // 检查科室CODE
          IMAGE_STATUS: 0, // 初始化检查为无图
          RIS_UPLOAD_STATUS: 0, // 初始化检查RIS图像未上传
          PACS_UPLOAD_STATUS: 0, // 初始化检查PACS图像未上传
          EXAM_STATUS: rowData.EXAM_STATUS || 0, // 检查状态
          PRINT_NUM: rowData.PRINT_NUM || 0, // 打印次数
          DELETE_FLAG: rowData.DELETE_FLAG || 0, // 删除标志
          CREATE_USER_UID: creatuser,
          BILLING_DOCTOR: values.BILLING_DOCTOR || null, //开单医生
          FROM_TYPE: fromType ? fromType : 0, //数据来源
          EDIT_USER_UID: userInfo.USER_UID, //编辑人
          EDIT_DATE: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"), //编辑时间
          //套餐检查量统计需要增加两个字段
          EXAM_SUB_CLASS_NAME,
          EXAM_CLASS_NAME,
        };
        SubmitInspect(Params, RequestModel).then((res) => {
          if (res && res.Status === 1) {
            // this.setState({ isSaveDisabled: false });
            let saveAndCheck = {
              isModalVisible: false,
            };
            if (value === "loggingEquipment") {
              this.loggingEquipment(res.Result.EXAM_UID, RequestModel.NAME);
              return;
            }
            switch (value) {
              case "preserve":
                this.props.onRef(saveAndCheck);
                this.props.form.resetFields();
                this.props.refreshTable(); //新增用户后刷新table表格
                break;
              case "inspect":
                saveAndCheck = {
                  isModalVisible: false,
                  checkVisible: true, // 开始检查
                  NAME: values.NAME,
                  SEX_NAME:
                    values.SEX === "U" ? "未知" : values.SEX === "M" ? "男" : values.SEX === "F" ? "女" : "未说明",
                  EXAM_UID: res.Result.EXAM_UID,
                  PATIENT_ID: res.Result.PATIENT_ID,
                  backResult: res.Result,
                  backName: values.NAME,
                  presInspect: res.Result.EXAM_UID,
                };
                this.props.onRef(saveAndCheck);
                this.props.form.resetFields();
                this.props.refreshTable(); //新增用户后刷新table表格
                this.props.paitentRefData(res.Result, values, value);
                break;
              case "getEcgData":
                saveAndCheck = {
                  isModalVisible: false,
                  checkVisible: true, // 开始检查
                  NAME: values.NAME,
                  SEX_NAME:
                    values.SEX === "U" ? "未知" : values.SEX === "M" ? "男" : values.SEX === "F" ? "女" : "未说明",
                  EXAM_UID: res.Result.EXAM_UID,
                  PATIENT_ID: res.Result.PATIENT_ID,
                };
                this.props.onRef(saveAndCheck);
                this.props.form.resetFields();
                this.props.refreshTable(); //新增用户后刷新table表格
                this.props.getEcgSeverData(res.Result, values, value, this.state.hisValue);
                break;
              default:
                break;
            }
            message.success("保存成功！");
          } else {
            if (value === "loggingEquipment") {
              message.error("录入失败，请检查填写信息");
            } else {
              message.error(res.Msg);
            }
            requestErrorLog(rowData.EXAM_UID, "新建/编辑保存接口报错", 0, true);
          }
        });
      }
    });
  };
  //录入血压信息
  loggingEquipment = (id, name) => {
    this.setState({
      loading: true,
    });
    let item = this.state.pressureObj;
    let BLOOD_PARAMETER = {
      DayStart_H: item.DayStart.split(":")[0],
      DayStart_M: item.DayStart.split(":")[1],
      DayFinish_H: item.DayFinish.split(":")[0],
      DayFinish_M: item.DayFinish.split(":")[1],
      DayInterval: parseInt(item.DayInterval) + "",
      WhetherFiveMin: "0",
      NightStart_H: item.NightStart.split(":")[0],
      NightStart_M: item.NightStart.split(":")[1],
      NightFinish_H: item.NightFinish.split(":")[1],
      NightFinish_M: item.NightFinish.split(":")[1],
      NightInterval: parseInt(item.NightInterval) + "",
      WhetherUseKeyboard: item.WhetherUseKeyboard === "启用" ? "1" : "0",
      WhetherUseDisplay: item.WhetherUseDisplay === "显示" ? "1" : "0",
      Special_1_Start_H: item.Special_1_Start ? item.Special_1_Start.split(":")[0] : "0",
      Special_1_Start_M: item.Special_1_Start ? item.Special_1_Start.split(":")[1] : "0",
      Special_1_Finish_H: item.Special_1_Finish ? item.Special_1_Finish.split(":")[1] : "0",
      Special_1_Finish_M: item.Special_1_Finish ? item.Special_1_Finish.split(":")[1] : "0",
      Special_1_Interval: parseInt(item.Special_1_Interval) + "",
      Special_2_Start_H: item.Special_2_Start ? item.Special_2_Start.split(":")[0] : "0",
      Special_2_Start_M: item.Special_2_Start ? item.Special_2_Start.split(":")[1] : "0",
      Special_2_Finish_H: item.Special_2_Finish ? item.Special_2_Finish.split(":")[1] : "0",
      Special_2_Finish_M: item.Special_2_Finish ? item.Special_2_Finish.split(":")[1] : "0",
      Special_2_Interval: parseInt(item.Special_2_Interval) + "",
      Special_3_Start_H: item.Special_3_Start ? item.Special_3_Start.split(":")[0] : "0",
      Special_3_Start_M: item.Special_3_Start ? item.Special_3_Start.split(":")[1] : "0",
      Special_3_Finish_H: item.Special_3_Finish ? item.Special_3_Finish.split(":")[1] : "0",
      Special_3_Finish_M: item.Special_3_Finish ? item.Special_3_Finish.split(":")[1] : "0",
      Special_3_Interval: parseInt(item.Special_3_Interval) + "",
      WhetherNightTip: item.WhetherNightTip === "启用" ? "1" : "0",
      WhetherDayTip: item.WhetherDayTip === "启用" ? "1" : "0",
    };
    console.log(id, name);
    let params = {
      TYPE: "BLOOD",
      PARAM: "WRITE_BLOOD",
      EXAM_UID: id,
      NAME: name,
      SERVER: window.g.baseURL,
      BLOOD_PARAMETER,
    };
    sendMessage(params);
    receiveMessage((data) => {
      this.props.getTransferStatus(data);
      if (data.RETURN_MSG === "录入成功") {
        this.setState({
          loading: false,
        });
        this.props.onRef({ isModalVisible: false });
        this.props.form.resetFields();
        this.props.refreshTable(); //新增用户后刷新table表格
        message.success("写入成功");
        localStorage.setItem("pressureObj", JSON.stringify(this.state.pressureObj));
      }
      if (data.RETURN_MSG === "录入失败") {
        this.setState({ loading: false });
        // this.props.onRef({ isModalVisible: false });
        message.error("录入失败，请检查设备连接状态");
      }
    });
  };

  initHospitalDept() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    const { rowData, clickStatus } = this.props;
    let Param = {
      Type: "Hospital_Dept", //申请科室
      hospital_Code: userInfo.HOSPITAL_CODE,
    };
    initHospitalDepts(Param).then((res) => {
      if (res && res.Status === 1) {
        let deptCode, deptName;
        if (res.Result[0]) {
          deptCode =
            clickStatus === "EASY" ? res.Result[0].DEPT_CODE : rowData.REQ_DEPT_CODE || localStorage.getItem("REQ_DEPT_CODE");
          deptName =
            clickStatus === "EASY" ? res.Result[0].DEPT_NAME : rowData.REQ_DEPT_NAME || localStorage.getItem("REQ_DEPT_NAME");
        }
        // this.initDoctor(deptCode);
        this.setState({
          departmentList: res.Result,
          deptCode,
          deptName,
        });
      } else {
        requestErrorLog("", "新建/编辑申请科室列表接口报错", 0, true);
      }
    });
  }

  initHospitalRoom(value) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let Param = {
      Type: "ExamRoomList", // 检查房间
      hospital_uid: userInfo.HOSPITAL_UID,
      DEPT_CODE: value,
    };
    initExamRoomList(Param).then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          hospitalRoomList: res.Result.ds,
        });
      } else {
        requestErrorLog("", "新建/编辑检查房间列表接口报错", 0, true);
      }
    });
  }

  initDoctor(code) {
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
    let Param = {
      Type: "Dept_Doctor", //申请医生
      hospital_Code: userInfo.HOSPITAL_CODE,
      Dept_Code: code,
    };
    initDeptDoctor(Param).then((res) => {
      if (res && res.Status === 1) {
        const doctor = res.Result;
        this.setState({
          doctorList: doctor,
        });
      } else {
        requestErrorLog("", "新建/编辑申请医生列表接口报错", 0, true);
      }
    });
  }

  handleHospitalDept = (value, option) => {
    //申请科室
    this.initDoctor(option.props.value);
    this.setState({
      deptCode: option.props.value,
      deptName: option.props.children,
      doctorCode: undefined,
      doctorName: undefined
    });
    this.props.form.setFieldsValue({
      REQ_DOCTOR_CODE: undefined,
      REQ_DOCTOR_NAME: undefined,
    });
  };
  checkType = (value, option) => {
    //点击检查类型
    this.setState({
      //保存检查类型选择的数据，同时带出来检查子类的数据
      checkTypeCode: option.props.value, //编码
      checkTypeName: option.props.children, //名字
    });
    let erji = this.state.dataLinkage.find((item) => item.id === value); //一级数据下的所有二级数据
    this.setState({
      inspectSubclassType: erji.child.map((item) => {
        //二级：检查子类的数据
        return {
          id: item.id,
          name: item.name,
          child: item.child,
        };
      }),
      inspectionItem: [],
    });
    //每次勾选检查类型，清掉检查子类和检查项目
    this.props.form.setFieldsValue({
      EXAM_SUB_CLASS: undefined,
      ITEM_NAME: undefined,
    });
  };
  handleDoctorSelect = (item, option) => {
    // 申请医生
    this.setState({
      doctorCode: option.props.value,
      doctorName: option.props.children,
    });
  };

  handleExamHospitalDept = (value, option) => {
    //检查科室
    this.initHospitalRoom(option.props.value);
    this.setState({
      examDeptCode: option.props.value,
      examDeptName: option.props.children,
    });
    this.props.form.setFieldsValue({
      EXAM_ROOM: undefined,
    });
  };

  handleItem = (item, option) => {
    // 检查项目
    this.setState({
      itemCode: option.props.value,
      itemName: option.props.children,
    });
  };

  handleChange = (result) => {
    this.setState({
      patientsourse: result,
    });
  };

  handleCancel = () => {
    this.props.onRef(false);
  };

  disabledDate(current) {
    //选择日期不能大于当前天
    return current > moment().endOf("day");
  }

  //血压值
  pressureObjChange = (item, value) => {
    if (!value) {
      return;
    }
    let obj = {};
    obj[item] = value;
    let data = Object.assign({}, this.state.pressureObj, obj);
    console.log(data);
    this.setState({
      pressureObj: data,
    });
  };
  pressureObjTimeChange = (item, value) => {
    if (!value) {
      return;
    }
    let obj = {};
    obj[item] = value.format("HH:mm");
    let data = Object.assign({}, this.state.pressureObj, obj);
    console.log(data);
    this.setState({
      pressureObj: data,
    });
  };
  //白天禁用选项
  getDayDisabledHours = () => {
    let hours = [];
    let time = this.state.pressureObj.DayStart;
    let timeArr = time.split(":")[0];
    for (var i = 0; i <= parseInt(timeArr); i++) {
      hours.push(i);
    }
    return hours;
  };
  //二级联动
  erji = (value, option) => {
    //点击检查子类
    this.setState({
      //保存检查子类选择的数据，同时带出来检查项目的数据
      checkchildTypeCode: option.props.value,
      EXAM_SUB_CLASS: value,
    });
    let sanji = this.state.inspectSubclassType.find((item) => item.id === value); //二级数据下的所有三级数据
    this.setState({
      inspectionItem: sanji.child,
    });
    //每次勾选检查项目清零
    this.props.form.setFieldsValue({
      ITEM_NAME: undefined,
    });
  };
  getMustInputList = () => {
    getOtherSettingListNo("1").then((res) => {
      if (res && res.Status === 1) {
        this.setState({
          is_BILLING_DOCTOR: res.Result.find((item) => item.REQUIRED_NAME.trim() === "开单医生")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "开单医生").ISREQUIRED
            : false,
          is_NAME_PHONETIC: res.Result.find((item) => item.REQUIRED_NAME.trim() === "英文姓名")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "英文姓名").ISREQUIRED
            : false, //英文姓名
          is_HEIGHT: res.Result.find((item) => item.REQUIRED_NAME.trim() === "身高")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "身高").ISREQUIRED
            : false, //身高
          is_EXAM_AGE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "年龄")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "年龄").ISREQUIRED
            : false, //年龄
          is_WEIGHT: res.Result.find((item) => item.REQUIRED_NAME.trim() === "体重")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "体重").ISREQUIRED
            : false, //体重
          is_CROWD_TYPE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "人群分类")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "人群分类").ISREQUIRED
            : false, //人群分类
          is_CHARGE_TYPE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "费别")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "费别").ISREQUIRED
            : false, //费别
          is_NATIVE_PLACE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "籍贯")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "籍贯").ISREQUIRED
            : false, //籍贯
          is_ZIP_CODE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "邮编")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "邮编").ISREQUIRED
            : false, //邮编
          is_INSURANCE_TYPE: res.Result.find((item) => item.REQUIRED_NAME.trim() === "医保性质")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "医保性质").ISREQUIRED
            : false, //医保性质
          is_INSURANCE_CARD_NO: res.Result.find((item) => item.REQUIRED_NAME.trim() === "医保卡号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "医保卡号").ISREQUIRED
            : false, //医保卡号
          is_CONTACT_TEL: res.Result.find((item) => item.REQUIRED_NAME.trim() === "手机号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "手机号").ISREQUIRED
            : false, //手机号
          is_ID_NUMBER: res.Result.find((item) => item.REQUIRED_NAME.trim() === "身份证号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "身份证号").ISREQUIRED
            : false, //身份证号
          is_HOME_ADDRESS: res.Result.find((item) => item.REQUIRED_NAME.trim() === "家庭住址")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "家庭住址").ISREQUIRED
            : false, //家庭住址
          is_MAILING_ADDRESS: res.Result.find((item) => item.REQUIRED_NAME.trim() === "通讯地址")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "通讯地址").ISREQUIRED
            : false, //通讯地址
          is_OUTP_NO: res.Result.find((item) => item.REQUIRED_NAME.trim() === "门诊号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "门诊号").ISREQUIRED
            : false, //门诊号
          is_REQ_DOCTOR_NAME: res.Result.find((item) => item.REQUIRED_NAME.trim() === "申请医生")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "申请医生").ISREQUIRED
            : false, //申请医生
          is_INP_NO: res.Result.find((item) => item.REQUIRED_NAME.trim() === "住院号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "住院号").ISREQUIRED
            : false, //住院号
          is_BED_NO: res.Result.find((item) => item.REQUIRED_NAME.trim() === "床号")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "床号").ISREQUIRED
            : false, //床号
          is_ROOM_NO: res.Result.find((item) => item.REQUIRED_NAME.trim() === "病区")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "病区").ISREQUIRED
            : false, //病区
          is_EXAM_ROOM: res.Result.find((item) => item.REQUIRED_NAME.trim() === "检查房间")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "检查房间").ISREQUIRED
            : false, //检查房间
          is_CHARGES: res.Result.find((item) => item.REQUIRED_NAME.trim() === "费用")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "费用").ISREQUIRED
            : false, //费用
          is_REQ_DATETIME: res.Result.find((item) => item.REQUIRED_NAME.trim() === "申请日期")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "申请日期").ISREQUIRED
            : false, //申请日期
          is_CLIN_DIAG: res.Result.find((item) => item.REQUIRED_NAME.trim() === "临床诊断")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "临床诊断").ISREQUIRED
            : false, //临床诊断
          is_PHYS_SIGN: res.Result.find((item) => item.REQUIRED_NAME.trim() === "体征")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "体征").ISREQUIRED
            : false, //体征
          is_CASE_HISTORY: res.Result.find((item) => item.REQUIRED_NAME.trim() === "病史")
            ? res.Result.find((item) => item.REQUIRED_NAME.trim() === "病史").ISREQUIRED
            : false, //病史
        });
      } else {
        requestErrorLog("", "新建/编辑其他配置项列表接口报错", 0, true);
      }
    });
  };
  changeHisValue = (e) => {
    this.setState({
      hisValue: e.target.value,
    });
  };
  getPatientInfo = (e) => {
    if (e.charCode === 13) {
      const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      let EXAM_NO = this.state.hisValue;
      getPatientInfo(EXAM_NO, userInfo.HOSPITAL_CODE).then((res) => {
        if (res && res.Status === 1) {
          let item = res.Result;
          if (item) {
            this.props.form.setFieldsValue({
              ...item,
              BIRTHDAY: moment(item.BIRTHDAY),
              NAME_PHONETIC: pinyin.getFullChars(item.NAME),
              REQ_DATETIME: item.REQ_DATETIME ? moment(item.REQ_DATETIME) : moment(),
            });
            //编辑时给检查子类复制
            this.setState({
              fromType: item.FROM_TYPE,
              checkTypeCode: item.EXAM_CLASS,
              EXAM_SUB_CLASS: item.EXAM_SUB_CLASS,
              deptName: item.REQ_DEPT_NAME,
              inspectionItem: [],
            });
            if (item.EXAM_CLASS) {
              let erji = this.state.dataLinkage.find((val) => val.id === item.EXAM_CLASS); //一级数据下的所有二级数据
              if (erji) {
                this.props.form.setFieldsValue({
                  EXAM_SUB_CLASS: item.EXAM_SUB_CLASS || erji.child[0].id, //'静息心电监测'
                });
                this.setState(
                  {
                    inspectSubclassType: erji.child.map((val) => {
                      //二级：检查子类的数据
                      return {
                        id: val.id,
                        name: val.name,
                        child: val.child,
                      };
                    }),
                  },
                  () => {
                    if (item.EXAM_SUB_CLASS) {
                      let sanji = this.state.inspectSubclassType.find((val) => {
                        return val.id === item.EXAM_SUB_CLASS;
                      }); //二级数据下的所有三级数据
                      if (sanji) {
                        this.props.form.setFieldsValue({
                          ITEM_NAME: item.ITEM_NAME || "", //'12导联静息心电检查',
                        });
                        this.setState({
                          inspectionItem: sanji.child,
                          itemName: item.ITEM_NAME || "",
                          itemCode: item.ITEM_NAME || "",
                        });
                      }
                    } else if (erji.child[0]?.id) {
                      let sanji = this.state.inspectSubclassType.find((val) => {
                        return val.id;
                      }); //二级数据下的所有三级数据
                      if (sanji && sanji.child.length > 0) {
                        this.props.form.setFieldsValue({
                          ITEM_NAME: item.ITEM_NAME || sanji.child[0].name, //'12导联静息心电检查',
                        });
                        this.setState({
                          inspectionItem: sanji.child,
                          itemName: item.ITEM_NAME || sanji.child[0].name,
                          itemCode: item.ITEM_NAME || sanji.child[0].id,
                        });
                      }
                    }
                  }
                );
              }
            }
            //患者来源自动回填
            if (!item.PATIENT_SOURCE) {
              this.props.form.setFieldsValue({
                PATIENT_SOURCE: this.state.sourceType[0]?.PATIENT_SOURCE_CODE,
              });
            }
            //申请科室自动回填
            if (!item.REQ_DEPT_NAME) {
              this.props.form.setFieldsValue({
                REQ_DEPT_NAME: this.state.departmentList[0]?.DEPT_CODE,
              });
              this.setState({
                deptCode: this.state.departmentList[0]?.DEPT_CODE,
                deptName: this.state.departmentList[0]?.DEPT_NAME,
              });
            }
          } else {
            this.props.form.resetFields();
            message.error("未找到对应患者");
          }
        } else {
          requestErrorLog("", "新建/编辑获取病人基本信息接口报错", 0, true);
        }
      });
    }
  };
  render() {
    const {
      costType,
      sexType,
      crowdType,
      holterData,
      medInsType,
      editDisabled,
      checkVisible,
      sourceType,
      inspectType,
      inspectSubclassType,
      inspectionItem,
      doctorList,
      departmentList,
      hospitalRoomList,
      pressureObj,
      is_NAME_PHONETIC,
      is_HEIGHT,
      is_EXAM_AGE,
      is_WEIGHT,
      is_CROWD_TYPE,
      is_CHARGE_TYPE,
      is_NATIVE_PLACE,
      is_ZIP_CODE,
      is_INSURANCE_TYPE,
      is_INSURANCE_CARD_NO,
      is_CONTACT_TEL,
      is_ID_NUMBER,
      is_HOME_ADDRESS,
      is_MAILING_ADDRESS,
      is_OUTP_NO,
      is_REQ_DOCTOR_NAME,
      is_INP_NO,
      is_BED_NO,
      is_ROOM_NO,
      is_BILLING_DOCTOR,
      is_EXAM_ROOM,
      is_CHARGES,
      is_REQ_DATETIME,
      is_CLIN_DIAG,
      is_PHYS_SIGN,
      is_CASE_HISTORY,
      // isSaveDisabled
    } = this.state;
    const {
      visible,
      title,
      rowData,
      clickStatus,
      form: { getFieldDecorator },
    } = this.props;
    const custService = JSON.parse(localStorage.getItem("QUERY_ALL"));
    const initialSubClassValue = () => {
      if (clickStatus === "ADD") {
        return inspectSubclassType.find((item) => item.id === this.state.EXAM_SUB_CLASS)?.id;
      } else if (clickStatus === "EASY") {
        return inspectSubclassType[0]?.id;
      } else {
        return inspectSubclassType.find((item) => item.id === rowData.EXAM_SUB_CLASS)?.id || inspectSubclassType[0]?.id;
      }
    };
    const initialItemValue = () => {
      let subClass = initialSubClassValue();
      if (!subClass) return undefined;
      // 2025年3月7日 增加客服权限回显判断
      return custService === 1 ? rowData.ITEM_CODE
			: clickStatus === "ADD" ? inspectionItem[0]?.id
				: clickStatus === "EASY" ? inspectionItem[0]?.id
					: rowData.ITEM_CODE;
      //2025年3月7日 新建后快速新建出现编码
      // return clickStatus === "ADD"
      // ? this.state.itemCode
      // : clickStatus === "EASY"
      //   ? this.state.itemCode || inspectionItem[0]?.id
      //   : rowData.ITEM_CODE;
    };
    return (
      <>
        {this.state.loading ? (
          <div className="MoadlLoading">
            <Spin size="large" tip="请稍等..." />
          </div>
        ) : null}
        {checkVisible ? (
          <StartCheck
            visible={checkVisible}
            rowData={rowData}
            holterData={holterData}
            onRef={(ref) => {
              this.setState({ checkVisible: ref });
            }}
          />
        ) : null}
        <Modal
          width="1200px"
          className="addPatientWrap"
          maskClosable={false}
          title={
            <div className="patient_title">
              <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
              <span>{title}</span>
            </div>
          }
          footer={
            <div>
              {custService !== 1 && clickStatus !== "EASY" ? (
                <div className="hisBox">
                  <span>唯一号</span>
                  <Input
                    style={{ width: 400 }}
                    value={this.state.hisValue}
                    onChange={this.changeHisValue}
                    onKeyPress={this.getPatientInfo}
                  />
                  <Button
                    id="bloodOne"
                    className="HISBUTTON"
                    key="his"
                    onClick={this.getPatientInfo.bind(this, { charCode: 13 })}
                  >
                    HIS信息获取{" "}
                  </Button>
                </div>
              ) : null}

              {this.state.checkTypeCode === "BloodPressure"
                ? clickStatus === "EDIT"
                  ? [
                    <Button id="bloodTwo" key="save" onClick={() => this.handleSubmitInspect("preserve")}>
                      保存
                    </Button>,
                    <Button id="bloodThree" key="exit" onClick={this.handleCancel}>
                      {" "}
                      退出
                    </Button>,
                  ]
                  : [
                    // 底部内容
                    <Button
                      id="bloodTwo"
                      key="save"
                      onClick={this.handleSubmitInspect.bind(this, "loggingEquipment")}
                    >
                      录入血压设备
                    </Button>,
                    // <Button id="brainNotCheck" key="commonCheck" disabled={clickStatus === 'EDIT'} onClick={this.extractBloodInfo} >提取血压信息</Button>,
                    <Button id="bloodThree" key="exit" onClick={this.handleCancel}>
                      {" "}
                      退出
                    </Button>,
                  ]
                : [
                  //待完善列表不可以接收心电图机及检查
                  custService !== 1 && this.state.checkTypeCode === "ECG" && parseInt(this.props.showKey) !== 4 ? (
                    <Button id="bloodOne" key="his" onClick={() => this.handleSubmitInspect("getEcgData")}>
                      接收心电图机数据{" "}
                    </Button>
                  ) : null,
                  <Button id="bloodTwo" key="save" onClick={() => this.handleSubmitInspect("preserve")}>
                    保存
                  </Button>,
                  custService !== 1 && parseInt(this.props.showKey) !== 4 ? (
                    <Button
                      id="brainNotCheck"
                      key="commonCheck"
                      disabled={editDisabled}
                      onClick={() => this.handleSubmitInspect("inspect")}
                    >
                      保存并检查
                    </Button>
                  ) : null,
                  <Button id="bloodThree" key="exit" onClick={this.handleCancel}>
                    {" "}
                    退出
                  </Button>,
                ]}
            </div>
          }
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div className="add_wrap">
            <Form layout="inline" ref={this.formRef}>
              <Form.Item label="姓名">
                {getFieldDecorator("NAME", {
                  rules: [
                    { required: true, message: "请输入姓名！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                  initialValue: clickStatus === "EASY" ? "默认姓名" : rowData.NAME,
                })(<Input onChange={(e) => handleEnglishName(e, this.props.form)} />)}
              </Form.Item>

              <Form.Item label="英文姓名">
                {getFieldDecorator("NAME_PHONETIC", {
                  initialValue: clickStatus === "EASY" ? "MoRenXingMing" : rowData.NAME_PHONETIC,
                  rules: [
                    { required: is_NAME_PHONETIC, message: "请输入英文姓名！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="性别">
                {getFieldDecorator("SEX", {
                  rules: [{ required: true, message: "请选择性别！" }],
                  initialValue: clickStatus === "EASY" ? "W" : rowData.SEX,
                })(
                  <Select placeholder="请选择性别">
                    {sexType &&
                      sexType.dt.map((item) => (
                        <Option value={item.DIC_CODE} key={item.DIC_CODE}>
                          {item.DIC_NAME}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="身高(cm)">
                {getFieldDecorator("HEIGHT", {
                  initialValue: rowData.HEIGHT,
                  rules: [
                    { required: is_HEIGHT, message: "请输入身高！" },
                    { pattern: /^[0-9]*$/, message: "请输入正整数" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="病历号">
                {getFieldDecorator("PATIENT_ID", {
                  initialValue: rowData.PATIENT_ID,
                })(<Input disabled />)}
              </Form.Item>

              <Form.Item label="年龄">
                {getFieldDecorator("EXAM_AGE", {
                  initialValue: rowData.EXAM_AGE,
                  rules: [
                    { required: is_EXAM_AGE, message: "请输入年龄！" },
                    {
                      message: "年龄不能超过150且必须为整数！",
                      pattern: /^[1][0-4][0-9]$|^[1-9]?[0-9]$|150/,
                    },
                  ],
                })(
                  <Input
                    min={1}
                    max={150}
                    onChange={(e) => changeAge(e, this.props.form)}
                    addonAfter={getFieldDecorator("AGE_UNIT", {
                      initialValue: clickStatus === "EDIT" ? rowData.AGE_UNIT : "岁",
                    })(
                      <Select
                        className="select-after"
                        onChange={(value) => handleChangeAgeUnit(value, this.props.form)}
                      >
                        <Option value="岁">岁</Option>
                        <Option value="月">月</Option>
                        <Option value="天">天</Option>
                      </Select>
                    )}
                  />
                )}
              </Form.Item>

              <Form.Item label="出生日期">
                {getFieldDecorator("BIRTHDAY", {
                  rules: [{ required: true, message: "请选择出生日期！" }],
                  initialValue: moment(rowData.BIRTHDAY),
                })(
                  <DatePicker
                    allowClear={false}
                    onChange={(date, dateString) => onChangeBirthday(date, dateString, this.props.form)}
                    disabledDate={this.disabledDate}
                  />
                )}
              </Form.Item>

              <Form.Item label="体重(kg)">
                {getFieldDecorator("WEIGHT", {
                  initialValue: rowData.WEIGHT,
                  rules: [
                    { required: is_WEIGHT, message: "请输入体重！" },
                    {
                      pattern: /^[0-9]+([.][0-9]{1,1})?$/,
                      message: "禁止输入空格",
                    },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="人群分类">
                {getFieldDecorator("CROWD_TYPE", {
                  initialValue: rowData.CROWD_TYPE,
                  rules: [
                    { required: is_CROWD_TYPE, message: "请输入人群分类！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(
                  <Select placeholder="请选择人群分类">
                    {crowdType &&
                      crowdType.dt.map((item) => (
                        <Option value={item.DIC_CODE} key={item.DIC_CODE}>
                          {item.DIC_NAME}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="费别">
                {getFieldDecorator("CHARGE_TYPE", {
                  initialValue: rowData.CHARGE_TYPE,
                  rules: [
                    { required: is_CHARGE_TYPE, message: "请输入费别！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(
                  <Select placeholder="请选择费别">
                    {costType &&
                      costType.dt.map((item) => (
                        <Option value={item.DIC_NAME} key={item.DIC_NAME}>
                          {item.DIC_NAME}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="籍贯">
                {getFieldDecorator("NATIVE_PLACE", {
                  initialValue: rowData.NATIVE_PLACE,
                  rules: [
                    { required: is_NATIVE_PLACE, message: "请输入籍贯！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="邮编">
                {getFieldDecorator("ZIP_CODE", {
                  initialValue: rowData.ZIP_CODE,
                  rules: [
                    { required: is_ZIP_CODE, message: "请输入邮编！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="医保性质">
                {getFieldDecorator("INSURANCE_TYPE", {
                  initialValue: rowData.INSURANCE_TYPE,
                  rules: [
                    {
                      required: is_INSURANCE_TYPE,
                      message: "请选择医保性质！",
                    },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(
                  <Select placeholder="请选择医保性质">
                    {medInsType &&
                      medInsType.dt.map((item) => (
                        <Option value={item.DIC_CODE} key={item.DIC_CODE}>
                          {item.DIC_NAME}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="医保卡号">
                {getFieldDecorator("INSURANCE_CARD_NO", {
                  initialValue: rowData.INSURANCE_CARD_NO,
                  rules: [
                    {
                      required: is_INSURANCE_CARD_NO,
                      message: "请输入医保卡号！",
                    },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="手机号">
                {getFieldDecorator("CONTACT_TEL", {
                  initialValue: rowData.CONTACT_TEL,
                  rules: [
                    { required: is_CONTACT_TEL, message: "请输入手机号！" },
                    { message: "请输入正确的手机号！", pattern: /^[0-9]*$/ },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="身份证号">
                {getFieldDecorator("ID_NUMBER", {
                  initialValue: rowData.ID_NUMBER,
                  rules: [
                    { required: is_ID_NUMBER, message: "请输入身份证号！" },
                    {
                      message: "请输入正确的身份证号！",
                      pattern: /^[\u9FA5a-zA-Z0-9_]{18}$/,
                    },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="家庭住址" className="row">
                {getFieldDecorator("HOME_ADDRESS", {
                  initialValue: rowData.HOME_ADDRESS,
                  rules: [
                    { required: is_HOME_ADDRESS, message: "请输入家庭住址！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input className="rowLine" />)}
              </Form.Item>

              <Form.Item label="通讯地址" className="row">
                {getFieldDecorator("MAILING_ADDRESS", {
                  initialValue: rowData.MAILING_ADDRESS,
                  rules: [
                    {
                      required: is_MAILING_ADDRESS,
                      message: "请输入通讯地址！",
                    },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input className="rowLine" />)}
              </Form.Item>

              <Form.Item label="检查号">
                {getFieldDecorator("EXAM_NO", {
                  initialValue: rowData.EXAM_NO,
                })(<Input disabled />)}
              </Form.Item>

              <Form.Item label="申请号">
                {getFieldDecorator("ACCESSIONNUMBER", {
                  initialValue: rowData.ACCESSIONNUMBER,
                })(<Input disabled />)}
              </Form.Item>

              <Form.Item label="患者来源">
                {getFieldDecorator("PATIENT_SOURCE", {
                  rules: [{ required: true, message: "请选择患者来源！" }],
                  initialValue: clickStatus === "EDIT" ? rowData.PATIENT_SOURCE : this.state.patientsourse,
                })(
                  <Select placeholder="请选择患者来源" onChange={this.handleChange}>
                    {sourceType &&
                      sourceType.map((item) => (
                        <Option value={item.PATIENT_SOURCE_CODE} key={item.PATIENT_SOURCE_CODE}>
                          {item.PATIENT_SOURCE_NAME}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="检查类型">
                {getFieldDecorator("EXAM_CLASS", {
                  rules: [{ required: true, message: "请选择检查类型！" }],
                  initialValue:
                    clickStatus === "ADD" || parseInt(this.props.showKey) === 4
                      ? this.state.checkTypeCode
                      : clickStatus === "EASY"
                        ? "ECG"
                        : rowData.EXAM_CLASS,
                })(
                  <Select
                    onSelect={this.checkType}
                    placeholder="请选择检查类型"
                    disabled={this.props.clickStatus !== "ADD"}
                  >
                    {inspectType &&
                      inspectType.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="申请科室">
                {getFieldDecorator("REQ_DEPT_NAME", {
                  rules: [{ required: true, message: "请选择申请科室！" }],
                  initialValue:
                    custService === 1
                      ? rowData.REQ_DEPT_NAME
                      : clickStatus === "EDIT"
                        ? rowData.REQ_DEPT_CODE
                        : this.state.deptCode,
                })(
                  <Select
                    disabled={custService === 1 ? true : false}
                    onSelect={this.handleHospitalDept}
                    placeholder="请选择申请科室"
                  >
                    {departmentList.map((item) => (
                      <Option key={item.DEPT_CODE} value={item.DEPT_CODE}>
                        {item.DEPT_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="门诊号">
                {getFieldDecorator("OUTP_NO", {
                  initialValue: rowData.OUTP_NO,
                  rules: [
                    { required: is_OUTP_NO, message: "请输入门诊号！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>
              <Form.Item label="检查子类">
                {getFieldDecorator("EXAM_SUB_CLASS", {
                  rules: [{ required: true, message: "请选择检查子类！" }],
                  initialValue: initialSubClassValue(),
                })(
                  <Select placeholder="请选择检查子类" onSelect={this.erji}>
                    {inspectSubclassType &&
                      inspectSubclassType.map((item) => (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="检查项目">
                {getFieldDecorator("ITEM_NAME", {
                  rules: [{ required: true, message: "请选择检查项目！" }],
                  initialValue: initialItemValue(),
                })(
                  <Select placeholder="请选择检查项目" onSelect={this.handleItem}>
                    {inspectionItem.map((item) => {
                      return (
                        <Option value={item.id} key={item.id}>
                          {item.name}
                        </Option>
                      );
                    })}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="申请医生">
                {getFieldDecorator("REQ_DOCTOR_NAME", {
                  initialValue: custService === 1 ? rowData.REQ_DOCTOR_NAME : rowData.REQ_DOCTOR_CODE,
                  rules: [
                    { required: is_REQ_DOCTOR_NAME, message: "请选择申请医生！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(
                  <Select
                    disabled={custService === 1 ? true : false}
                    onSelect={this.handleDoctorSelect}
                    placeholder="请选择申请医生"
                  >
                    {doctorList.map((item) => (
                      <Option value={item.USER_UID} key={item.USER_UID}>
                        {item.REAL_NAME}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="住院号">
                {getFieldDecorator("INP_NO", {
                  initialValue: rowData.INP_NO,
                  rules: [
                    { required: is_INP_NO, message: "请输入住院号！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="床号">
                {getFieldDecorator("BED_NO", {
                  initialValue: rowData.BED_NO,
                  rules: [
                    { required: is_BED_NO, message: "请输入床号！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="病区">
                {getFieldDecorator("ROOM_NO", {
                  initialValue: rowData.ROOM_NO,
                  rules: [
                    { required: is_ROOM_NO, message: "请输入病区！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input />)}
              </Form.Item>

              <Form.Item label="开单医生">
                {getFieldDecorator("BILLING_DOCTOR", {
                  initialValue: rowData.BILLING_DOCTOR,
                  rules: [
                    {
                      required: is_BILLING_DOCTOR,
                      message: "请输入开单医生！",
                    },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input placeholder="请输入开单医生" />)}
              </Form.Item>

              <Form.Item label="检查房间">
                {getFieldDecorator("EXAM_ROOM", {
                  initialValue: rowData.EXAM_ROOM,
                  rules: [
                    { required: is_EXAM_ROOM, message: "请选择检查房间！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(
                  <Select placeholder="请选择检查房间">
                    {hospitalRoomList.map((item) => (
                      <Select.Option key={item.ROOM_NAME} value={item.ROOM_NAME}>
                        {item.ROOM_NAME}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>

              <Form.Item label="费用">
                {getFieldDecorator("CHARGES", {
                  initialValue: rowData.CHARGES,
                  rules: [
                    { required: is_CHARGES, message: "请输入费用！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<InputNumber />)}
              </Form.Item>

              <Form.Item label="创建日期">
                {getFieldDecorator("REQ_DATETIME", {
                  initialValue: moment(rowData.REQ_DATETIME),
                  rules: [{ required: is_REQ_DATETIME, message: "请输入创建日期！" }],
                })(<DatePicker disabled disabledDate={this.disabledDate} />)}
              </Form.Item>

              <Form.Item label="临床诊断" className="row">
                {getFieldDecorator("CLIN_DIAG", {
                  initialValue: rowData.CLIN_DIAG,
                  rules: [
                    { required: is_CLIN_DIAG, message: "请输入临床诊断！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input className="rowLine" />)}
              </Form.Item>

              <Form.Item label="体征" className="row">
                {getFieldDecorator("PHYS_SIGN", {
                  initialValue: rowData.PHYS_SIGN,
                  rules: [
                    { required: is_PHYS_SIGN, message: "请输入体征！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input className="rowLine" />)}
              </Form.Item>

              <Form.Item label="病史" className="row">
                {getFieldDecorator("CASE_HISTORY", {
                  initialValue: rowData.CASE_HISTORY,
                  rules: [
                    { required: is_CASE_HISTORY, message: "请输入病史！" },
                    { pattern: /^[^\s]*$/, message: "禁止输入空格" },
                  ],
                })(<Input className="rowLine" />)}
              </Form.Item>
              {this.state.checkTypeCode === "BloodPressure" ? (
                <div>
                  <div className="pressureBox">
                    <span className="label">白天</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      value={moment(pressureObj.DayStart, "HH:mm")}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjTimeChange.bind(this, "DayStart")}
                      allowClear={false}
                    />
                    <span className="interval">到</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      disabledHours={this.getDayDisabledHours}
                      value={moment(pressureObj.DayFinish, "HH:mm")}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjTimeChange.bind(this, "DayFinish")}
                      allowClear={false}
                    />
                    <span className="label">间隔</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.DayInterval}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "DayInterval")}
                    >
                      {this.state.dateInterval.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    <span className="label">白天报警</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.WhetherDayTip}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "WhetherDayTip")}
                    >
                      <Option key="启用">启用</Option>
                      <Option key="停用">停用</Option>
                    </Select>
                  </div>
                  <div className="pressureBox">
                    <span className="label">夜间</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={moment(pressureObj.NightStart, "HH:mm")}
                      onChange={this.pressureObjTimeChange.bind(this, "NightStart")}
                      allowClear={false}
                    />
                    <span className="interval">到</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={moment(pressureObj.NightFinish, "HH:mm")}
                      onChange={this.pressureObjTimeChange.bind(this, "NightFinish")}
                      allowClear={false}
                    />
                    <span className="label">间隔</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.NightInterval}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "NightInterval")}
                    >
                      {this.state.dateInterval.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    <span className="label">夜间报警</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.WhetherNightTip}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "WhetherNightTip")}
                    >
                      <Option key="启用">启用</Option>
                      <Option key="停用">停用</Option>
                    </Select>
                  </div>
                  <div className="pressureBox">
                    <span className="label">特殊1</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_1_Start ? moment(pressureObj.Special_1_Start, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_1_Start")}
                      allowClear={false}
                    />
                    <span className="interval">到</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_1_Finish ? moment(pressureObj.Special_1_Finish, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_1_Finish")}
                      allowClear={false}
                    />
                    <span className="label">间隔</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.Special_1_Interval ? pressureObj.Special_1_Interval : undefined}
                      placeholder="请选择间隔"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "Special_1_Interval")}
                    >
                      {this.state.dateInterval.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    <span className="label">键盘</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.WhetherUseKeyboard}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "WhetherUseKeyboard")}
                    >
                      <Option key="启用">启用</Option>
                      <Option key="停用">停用</Option>
                    </Select>
                  </div>
                  <div className="pressureBox">
                    <span className="label">特殊2</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_2_Start ? moment(pressureObj.Special_2_Start, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_2_Start")}
                      allowClear={false}
                    />
                    <span className="interval">到</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_2_Finish ? moment(pressureObj.Special_2_Finish, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_2_Finish")}
                      allowClear={false}
                    />
                    <span className="label">间隔</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.Special_2_Interval ? pressureObj.Special_2_Interval : undefined}
                      placeholder="请选择间隔"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "Special_2_Interval")}
                    >
                      {this.state.dateInterval.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                    <span className="label">显示</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.WhetherUseDisplay}
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "WhetherUseDisplay")}
                    >
                      <Option key="启用">启用</Option>
                      <Option key="停用">停用</Option>
                    </Select>
                  </div>
                  <div className="pressureBox">
                    <span className="label">特殊3</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_3_Start ? moment(pressureObj.Special_3_Start, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_3_Start")}
                      allowClear={false}
                    />
                    <span className="interval">到</span>
                    <TimePicker
                      format={"HH:mm"}
                      minuteStep={30}
                      hideDisabledOptions
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      value={pressureObj.Special_3_Finish ? moment(pressureObj.Special_3_Finish, "HH:mm") : null}
                      onChange={this.pressureObjTimeChange.bind(this, "Special_3_Finish")}
                      allowClear={false}
                    />
                    <span className="label">间隔</span>
                    <Select
                      className="dateInterval"
                      value={pressureObj.Special_3_Interval ? pressureObj.Special_3_Interval : undefined}
                      placeholder="请选择间隔"
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      onChange={this.pressureObjChange.bind(this, "Special_3_Interval")}
                    >
                      {this.state.dateInterval.map((item, index) => (
                        <Option key={index} value={item}>
                          {item}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              ) : null}
            </Form>
          </div>
        </Modal>
      </>
    );
  }
}

export default Form.create({})(patientModal);
